module.exports = __webpack_public_path__ + "static/media/tab-slurp-crunchy.aa14fd00.png";